import mattress from "../navigation/StaticWhyEvrBed/Mattress";
import {feetInchRegex} from "../constants/regex";
import {useSelector} from "react-redux";
import { useDispatch } from "react-redux";
import {
  setPrimarySleeperFinalEvrScore,
  setSecondarySleeperFinalEvrScore
} from "../redux/slices/mattressConfiguration";

export const shopifyProductVariants = {
  twin: "39846953353294",
  queen: "39846953386062",
  king: "39846953418830",
  caliKing: "39846953484366",
};

const sleeperFirmnessVariants = [
  "empty - no 0 option",
  "39965053714510",  // 1
  "39965053747278",  // 2
  "39965053780046",  // 3
  "39965053812814",  // 4
  "39965053845582",  // 5
];

const sleeperPainVariants = {
  hip: "39965052862542",
  shoulder: "39965052895310",
  lowerBack: "39965052928078",
  midBack: "39965052960846",
};

const sleeperPrimarySleepStyleVariants = [
  "39965044473934", // Side
  "39965044506702", // Back
  "39965044539470", // Stomach
  "39965044572238", // Varied
];

const sleeperSecondarySleepStyleVariants = [
  "39965045784654", // Side
  "39965045817422", // Back
  "39965045850190", // Stomach
  "39965045882958", // Varied
];

const sleeperEvrScore = [
  "empty - no 0 option",
  "39965029138510",  // 1
  "39965037494350",  // 2
  "39965037527118",  // 3
  "39965037559886",  // 4
  "39965037592654",  // 5
  "39965037625422",  // 6
  "39965037658190",  // 7
  "39965037690958",  // 8
  "39965037723726",  // 9
  "39965037756494",  // 10
  "39965037789262",  // 11
  "39965038018638",  // 12
  "39965038051406",  // 13
  "39965038084174",  // 14
  "39965038116942",  // 15
  "39965038149710",  // 16
  "39965038182478",  // 17
  "39965038215246",  // 18
  "39965038248014",  // 19
  "39965038280782",  // 20
  "39965038313550",  // 21
  "39965038346318",  // 22
  "39965038379086",  // 23
  "39965038411854",  // 24
  "39965038444622",  // 25
  "39965038477390",  // 26
  "39965038510158",  // 27
  "39965038542926",  // 28
  "39965038575694",  // 29
  "39965038608462",  // 30
  "39965038641230",  // 31
  "39965038673998",  // 32
  "39965038706766",  // 33
  "39965038739534",  // 34
  "39965038772302",  // 35
  "39965038805070",  // 36
  "39965038837838",  // 37
  "39965038870606",  // 38
  "39965038903374",  // 39
  "39965038936142",  // 40
  "39965038968910",  // 41
  "39965039001678",  // 42
  "39965039034446",  // 43
  "39965039067214",  // 44
  "39965039099982",  // 45
  "39965039132750",  // 46
  "39965039165518",  // 47
  "39965039198286",  // 48
  "39965039231054",  // 49
  "39965039263822",  // 50
  "39965039296590",  // 51
  "39965039329358",  // 52
  "39965039362126",  // 53
  "39965039394894",  // 54
  "39965039427662",  // 55
  "39965039460430",  // 56
  "39965039493198",  // 57
  "39965039525966",  // 58
  "39965039558734",  // 59
  "39965039591502",  // 60
  "39965039624270",  // 61
  "39965039657038",  // 62
  "39965039689806",  // 63
  "39965039722574",  // 64
  "39965039755342",  // 65
  "39965039788110",  // 66
  "39965039820878",  // 67
  "39965039853646",  // 68
  "39965039886414",  // 69
  "39965039919182",  // 70
  "39965039951950",  // 71
  "39965039984718",  // 72
  "39965040017486",  // 73
  "39965040050254",  // 74
  "39965040083022",  // 75
  "39965040115790",  // 76
  "39965040148558",  // 77
  "39965040181326",  // 78
  "39965040214094",  // 79
  "39965040246862",  // 80
];


const partnerFirmnessVariants = [
  "empty - no 0 option",
  "39965054402638",  // 1
  "39965054435406",  // 2
  "39965054468174",  // 3
  "39965054500942",  // 4
  "39965054533710",  // 5
];

const partnerPainVariants = {
  hip: "39965053190222",
  shoulder: "39965053222990",
  lowerBack: "39965053255758",
  midBack: "39965053288526",
};

const partnerPrimarySleepStyleVariants = [
  "39965046767694", // Side
  "39965046833230", // Back
  "39965046898766", // Stomach
  "39965046964302", // Varied
];

const partnerSecondarySleepStyleVariants = [
  "39965048143950", // Side
  "39965048176718", // Back
  "39965048209486", // Stomach
  "39965048242254", // Varied
];

const partnerEvrScore = [
  "empty - no 0 option",
  "39965036773454",  // 1
  "39965041393742",  // 2
  "39965041426510",  // 3
  "39965041459278",  // 4
  "39965041492046",  // 5
  "39965041524814",  // 6
  "39965041557582",  // 7
  "39965041590350",  // 8
  "39965041623118",  // 9
  "39965041655886",  // 10
  "39965041688654",  // 11
  "39965041721422",  // 12
  "39965041754190",  // 13
  "39965041786958",  // 14
  "39965041819726",  // 15
  "39965041852494",  // 16
  "39965041885262",  // 17
  "39965041918030",  // 18
  "39965041950798",  // 19
  "39965041983566",  // 20
  "39965042016334",  // 21
  "39965042049102",  // 22
  "39965042081870",  // 23
  "39965042114638",  // 24
  "39965042147406",  // 25
  "39965042180174",  // 26
  "39965042212942",  // 27
  "39965042245710",  // 28
  "39965042278478",  // 29
  "39965042311246",  // 30
  "39965042344014",  // 31
  "39965042376782",  // 32
  "39965042409550",  // 33
  "39965042442318",  // 34
  "39965042475086",  // 35
  "39965042507854",  // 36
  "39965042540622",  // 37
  "39965042573390",  // 38
  "39965042606158",  // 39
  "39965042638926",  // 40
  "39965042671694",  // 41
  "39965042704462",  // 42
  "39965042737230",  // 43
  "39965042769998",  // 44
  "39965042802766",  // 45
  "39965042835534",  // 46
  "39965042868302",  // 47
  "39965042901070",  // 48
  "39965042933838",  // 49
  "39965042966606",  // 50
  "39965042999374",  // 51
  "39965043032142",  // 52
  "39965043064910",  // 53
  "39965043097678",  // 54
  "39965043130446",  // 55
  "39965043163214",  // 56
  "39965043195982",  // 57
  "39965043228750",  // 58
  "39965043261518",  // 59
  "39965043294286",  // 60
  "39965043327054",  // 61
  "39965043359822",  // 62
  "39965043392590",  // 63
  "39965043425358",  // 64
  "39965043458126",  // 65
  "39965043490894",  // 66
  "39965043523662",  // 67
  "39965043556430",  // 68
  "39965043589198",  // 69
  "39965043621966",  // 70
  "39965043654734",  // 71
  "39965043687502",  // 72
  "39965043720270",  // 73
  "39965043753038",  // 74
  "39965043785806",  // 75
  "39965043818574",  // 76
  "39965043851342",  // 77
  "39965043884110",  // 78
  "39965043916878",  // 79
  "39965043949646",  // 80
];

export const SHOPIFY_URL = "https://evrbed.com/";

//                                           King             2 sleepers       44 evrscore      pri side        sec stomach     Hip pain         lower back       Extra Firm
const testUrl = "https://evrbed.com/cart/39846953418830:1,39964986736718:1,39965039067214:1,39965044473934:1,39965045850190:1,39965052862542:1,39965052928078:1,39965053845582:1?checkout[email]=ben%2Btest123@geekinc.ca&note=test-note-1 test2, test3";



const weightRangeInKg = [
  0, 45.36, 54.43, 63.5, 72.57, 81.65, 90.71, 99.79, 108.86, 117.93, 127,
  136.07,
];
const heightRangeInCm = [0, 152.4, 160, 167.64, 175.26, 182.88, 190.5, 198.12];

const evrScoreMatrix = [
  [22, 22, 33, 34, 34, 44, 44, 55, 55, 55, 56, 56],
  [22, 22, 23, 33, 33, 44, 44, 45, 55, 55, 56, 56],
  [22, 22, 23, 33, 33, 34, 34, 45, 55, 55, 55, 56],
  [22, 12, 22, 23, 23, 33, 34, 44, 45, 55, 55, 55],
  [12, 12, 22, 22, 23, 33, 33, 44, 44, 45, 45, 45],
  [12, 12, 12, 22, 22, 23, 33, 34, 44, 45, 45, 45],
  [12, 12, 12, 12, 22, 23, 33, 34, 44, 45, 45, 45],
  [12, 12, 12, 12, 12, 22, 23, 33, 34, 44, 45, 45],
];

export const getEvrScore = (weight, height) => {
  const heightIndex = getRangeIndex(heightRangeInCm, height);
  const weightIndex = getRangeIndex(weightRangeInKg, weight);
  return evrScoreMatrix[heightIndex][weightIndex];
};

const getRangeIndex = (array, value) => {
  let finalIndex;
  array.map((element, index) => {
    if (index !== array.length - 1) {
      if (value >= element && value <= array[index + 1]) {
        return (finalIndex = index);
      }
    } else if (index === array.length - 1 && finalIndex === undefined) {
      return (finalIndex = index);
    }
  });
  return finalIndex;
};

export const parseFeetInchToCm = height => {
  const { feet, inch } = parseFeetAndInch(height);
  const heightInInch = feet * 12 + inch;
  return (heightInInch * 2.54).toFixed(2);
};

export const parseFeetAndInch = feetInchString => {
  const rex = feetInchRegex;
  let feetInchCorrectString = feetInchString.replace(/ /g, '');
  if (feetInchString.slice(-1) !== '"') {
    feetInchCorrectString = feetInchCorrectString + '"';
  }
  const match = rex.exec(feetInchCorrectString);
  let feet = null;
  let inch = null;
  if (match) {
    feet = parseInt(match[1], 10);
    inch = parseInt(match[2], 10);
  }
  return { feet, inch };
};

export const convertLbsToKg = weightInLBS => {
  return (weightInLBS * 0.45359237).toFixed(2);
};

const getBodyTypeAdjustmentValue = bodyType => {
  if (bodyType === 1) {
    return -10;
  } else if (bodyType === 2) {
    return -1;
  }
  return 0;
};

const getBodyTypeText = (bodyType) => {
  switch (bodyType) {
  case 0:
  case "0":
    return "Muscled and toned";
  case 1:
  case "1":
    return "Slim and Lean";
  case 2:
  case "2":
    return "Curvy and full-figured";
  }
};

const getSleepPositionsAdjustmentValue = sleepPosition => {
  if (sleepPosition === 1) {
    return 1;
  } else if (sleepPosition === 2) {
    return 11;
  }
  return 0;
};

const getFirmnessAdjustmentValue = firmness => {
  const adjustmentValues = [0, -22, -11, 0, 11, 22];
  return adjustmentValues[firmness];
};

export const getFinalEvrScore = ({ isPrimarySleeper, state }) => {
  // Get basic evrscore based on height and weight
  let finalEvrScore;
  let bodyType;
  let sleepPosition;
  let firmness;

  const primarySleeperFinalEvrScore = useSelector(setPrimarySleeperFinalEvrScore);
  const secondarySleeperFinalEvrScore = useSelector(setSecondarySleeperFinalEvrScore);
  const dispatch = useDispatch();

  let config = state.mattressConfiguration;
  let sleeper = config.mattressBuilder.primarySleeper;
  let partner = config.mattressBuilder.secondarySleeper;

  if (isPrimarySleeper) {
    //Assign evrscore
    finalEvrScore = getEvrScore(sleeper.weight, sleeper.height);
    //Assign bodyType
    bodyType = sleeper.bodyType;
    //Assign sleep position
    sleepPosition = sleeper.primarySleepStyle;
    //Assign firmness
    firmness = sleeper.firmness;
  } else {
    //Assign evrscore
    finalEvrScore = getEvrScore(partner.weight, partner.height);
    //Assign bodyType
    bodyType = partner.bodyType;
    //Assign sleep position
    sleepPosition = partner.primarySleepStyle;
    //Assign firmness
    firmness = partner.firmness;
  }


  bodyType = bodyType ? bodyType : 0;
  sleepPosition = sleepPosition ? sleepPosition : 0;
  firmness = firmness ? firmness : 0;
  finalEvrScore = finalEvrScore ? finalEvrScore : 0;

  // Body Type
  finalEvrScore = finalEvrScore + getBodyTypeAdjustmentValue(bodyType);
  // Sleep Positions
  finalEvrScore = finalEvrScore + getSleepPositionsAdjustmentValue(sleepPosition);
  // Pain Points ???

  // Firmness
  finalEvrScore = finalEvrScore + getFirmnessAdjustmentValue(firmness);
  if (isNaN(finalEvrScore)) {
    return "--";
  }

  if (isPrimarySleeper) {
    dispatch(setPrimarySleeperFinalEvrScore(finalEvrScore));
  } else {
    dispatch(setSecondarySleeperFinalEvrScore(finalEvrScore));
  }
  return finalEvrScore;
};

export function constructRedirectUrl(state) {
  let url = SHOPIFY_URL + "cart/";

  // To construct this properly, the items need to be loaded in reverse order
  //                                                            -------------

  // Load up the current config
  let config = state.mattressConfiguration;
  console.log(JSON.stringify(config));

  // Start with the partner
  if (config.mattressConfiguration.isSingleSleeper !== true) {
    let partner = config.mattressBuilder.secondarySleeper;
    url += partnerFirmnessVariants[partner.firmness] + ":1,";

    // Pain Points
    if (partner.painPoints.hip) {
      url += partnerPainVariants.hip + ":1,";
    }
    if (partner.painPoints.shoulder) {
      url += partnerPainVariants.shoulder + ":1,";
    }
    if (partner.painPoints.lowerBack) {
      url += partnerPainVariants.lowerBack + ":1,";
    }
    if (partner.painPoints.midBack) {
      url += partnerPainVariants.midBack + ":1,";
    }

    // Sleep Style
    if (partner.secondarySleepStyle >= 0) {
      url += partnerSecondarySleepStyleVariants[partner.secondarySleepStyle] + ":1,";
    }
    if (partner.primarySleepStyle >= 0) {
      url += partnerPrimarySleepStyleVariants[partner.primarySleepStyle] + ":1,";
    }

    // EvrScore
    if (partner.finalEvrScore) {
      url += partnerEvrScore[partner.finalEvrScore] + ":1,";
    }
  }

  // Move to main sleeper
  let sleeper = config.mattressBuilder.primarySleeper;
  url += sleeperFirmnessVariants[sleeper.firmness] + ":1,";

  // Pain Points
  if (sleeper.painPoints.hip) {
    url += sleeperPainVariants.hip + ":1,";
  }
  if (sleeper.painPoints.shoulder) {
    url += sleeperPainVariants.shoulder + ":1,";
  }
  if (sleeper.painPoints.lowerBack) {
    url += sleeperPainVariants.lowerBack + ":1,";
  }
  if (sleeper.painPoints.midBack) {
    url += sleeperPainVariants.midBack + ":1,";
  }

  // Sleep Style
  if (sleeper.secondarySleepStyle >= 0) {
    url += sleeperSecondarySleepStyleVariants[sleeper.secondarySleepStyle] + ":1,";
  }
  if (sleeper.primarySleepStyle >= 0) {
    url += sleeperPrimarySleepStyleVariants[sleeper.primarySleepStyle] + ":1,";
  }

  // EvrScore
  if (sleeper.finalEvrScore) {
    url += sleeperEvrScore[sleeper.finalEvrScore] + ":1,";
  }

  // Height
  let note = "?note=";
  if (sleeper.height) {
    note += encodeURIComponent("Sleeper 1 Height: " + sleeper.height);
    console.log(1);
  }
  if (config.mattressConfiguration.isSingleSleeper !== true && config.mattressBuilder.secondarySleeper.height) {
    note += encodeURIComponent(", Sleeper 2 Height: " + config.mattressBuilder.secondarySleeper.height);
    console.log(2);
  }
  if (sleeper.weight) {
    note += encodeURIComponent(", Sleeper 1 Weight: " + sleeper.weight);
    console.log(3);
  }
  if (config.mattressConfiguration.isSingleSleeper !== true && config.mattressBuilder.secondarySleeper.weight) {
    note += encodeURIComponent(", Sleeper 2 Weight: " + config.mattressBuilder.secondarySleeper.weight);
    console.log(4);
  }
  if (sleeper.bodyType > -1) {
    note += encodeURIComponent(", Sleeper 1 Body Type: " + getBodyTypeText(sleeper.bodyType));
    console.log(5);
  }
  if (config.mattressConfiguration.isSingleSleeper !== true && config.mattressBuilder.secondarySleeper.bodyType > -1) {
    note += encodeURIComponent(", Sleeper 2 Body Type: " + getBodyTypeText(config.mattressBuilder.secondarySleeper.bodyType));
    console.log(6);
  }
  console.log(note);
  console.log(JSON.stringify(config.mattressBuilder));

  if (config.mattressConfiguration.bedSize) {
    url += shopifyProductVariants[config.mattressConfiguration.bedSize] + ":1";
  }
  url += note;
  console.log(url);

  return url;

}